import { GlobalService } from "src/app/_services/global.service";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Subject } from "rxjs";
const devUrl = environment.backendurl


@Injectable({
    providedIn: 'root'
})
export class UploadCandidateService {

    constructor(private http: HttpClient) { }


    private reRunScreeningResponse: Subject<any> = new Subject<any>();

    setReRunScreeningResponse(response: any) {
        this.reRunScreeningResponse.next(response);
    }

    getReRunScreeningResponse() {
        return this.reRunScreeningResponse.asObservable();
    };

    private screeningSuccessMessageSubject = new BehaviorSubject<string>('');
    screeningSuccessMessage$ = this.screeningSuccessMessageSubject.asObservable();

    setScreeningSuccessMessage(message: string): void {
        this.screeningSuccessMessageSubject.next(message);
    }

    clearScreeningSuccessMessage(): void {
        this.screeningSuccessMessageSubject.next('');
    }


    /** Method To get the candidate details */
    private selectedCandidateDetailsSubject = new Subject<any[]>();

    setCandidateSelectedData(data: any[]): void {
        this.selectedCandidateDetailsSubject.next(data);
    };

    getCandidateSelectedData(): any {
        return this.selectedCandidateDetailsSubject.asObservable();
    };

    /**
      * Upload resume in bulk
      * @param data
      * @param projectnumber
      * @returns
      */
    parsheResumeForUploadCandidate(data: any, projectnumber: string) {
        let formData: FormData = new FormData();
        formData.append('resume', data);
        var url = devUrl + `/unified/integrations/${projectnumber}/upload/resumes`
        return this.http.post<any>(url, formData, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
            , catchError(GlobalService.handleError('Document Upload', url)));
    };


    /**
     * Create bulk candidate with uploaded resume
     * @param payload 
     * @param projectnumber 
     * @returns 
     */
    createBulkCandidate(payload: any, projectnumber: string) {
        const url = devUrl + `/unified/integrations/${projectnumber}/createcandidate/bulk`;
        return this.http.post(url, { candidates: payload }, { observe: 'response' }).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Create Candidate: ', url)));
    };

    /**
     * Create bulk candidate with uploaded resume
     * @param payload 
     * @param projectnumber 
     * @returns 
     */
    getUploadCandidateList(payload: any, projectnumber: string) {
        const url = devUrl + `/unified/integrations/project/${projectnumber}/candidates`;
        return this.http.post(url, payload, { observe: 'response' }).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Get Uploaded Candidate List: ', url)));
    };


    /**
     * Fetches the upload candidate explanation for a candidate.
     * @param payload The payload containing the candidate information.
     * @returns An observable containing the project explanation.
     */

    getUploadCandidateExplanation(payload: any) {
        const url = devUrl + "/unified/integrations/application/screen/explanation";
        return this.http.post(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch project explanation: ', url)));
    };



    /**
     * Re-runs the screening process for the specified candidates.
     * @param payload The payload containing the candidate information.
     * @returns An observable containing the re-run results.
     */
    getUploadCandidateReRun(payload: any) {
        const url = devUrl + "/unified/integrations/application/screen";
        return this.http.post(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Re Run Screen: ', url)));
    };


    /**
      * Fetches the long summary for the specified candidate.
      * @param payload The payload containing the candidate information.
      * @returns An observable containing the long summary.
      */
    getCandidateLognSummary(payload: any) {
        const url = devUrl + "/personsearch/longsummary";
        return this.http.post(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch Long Summary: ', url)));
    };

    /**
     * Fetches the candidate count for the specified project.
     * @param payload The payload containing the candidate information.
     * @param projectnumber The project number.
     * @returns An observable containing the candidate count.
     */
    getCandidateCount(payload: any, projectnumber: string) {
        const url = devUrl + `/unified/integrations/project/${projectnumber}/candidatecount`;
        return this.http.post(url, payload).pipe(map(response => { return response; })
            , catchError(GlobalService.handleError('Fetch Candidate Count: ', url)));
    };

    previewCandidateResume(candidateId: string, docurl: string) {
        const url = devUrl + `/unified/integrations/${candidateId}/candidate/download?url=` + docurl;
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((response: any) => { return response })

            , catchError(GlobalService.handleError('resumeurl', url)));
    }

};